import { ApplicationWithDetails } from '../../../types';
import { aidaPlans } from './AidaPlans';
import { TgBotInstructions } from './TgBotInstructions/TgBotInstructions';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AIDA_copy: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EBD44`,
	// eslint-disable-next-line sonarjs/no-duplicate-string
	name: `Aida Bott`,
	description: `Уведомления о стопах, тикетах и днях рождения`,
	descriptionLong: `Хотите управлять пиццерией с экрана телефона? Хотите быстро давать обратную связь клиентам?  Подпишитесь на оповещения о стопах и тикетах в телеграм-боте. \nКонтролируйте стопы, следите за оценками клиентов прямо у себя в телефоне.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/aida/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/aida/bgr`,
	sliders: [
		// eslint-disable-next-line sonarjs/no-duplicate-string
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-1`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-2`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-3`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-4`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-5`,
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: `https://uk-vkus.ru/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `Телеграм-чат`,
	supportEmail: `https://t.me/+TSY5w7zNctg4NzBi`,
	categories: [`Уведомления`, `Мониторинг производства`, `Обратная связь`, `Клиенты`],
	countries: [`Все`],
	languages: [`Русский`],
	conceptions: [`Dodo Pizza`],
	price: `Бесплатно`,
	version: `1.0`,
	type: `Бот`,
	developer: `УК Вкус`,
	plans: aidaPlans,
	instructions: TgBotInstructions,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: false,
	versionHistory: `https://www.notion.so/aidavkusbot/AIDa-d498babf0857405c947d7d6b3d1583ee`,
	goToApp: true,
	hasFreePlan: true,
};
